const ENV = {
    get base_url_api_v1() {
        return "https://test.filbet2025.com"
    },
    get dev_mode() {
        const o = import.meta.env.DEV || import.meta.env.MODE === "development"
        return o
    },
    get is_hash_router() {
        return false
    },
}

export default ENV
